export class ListBackupPostureControlsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<BackupPostureControlSort>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListBackupPostureControlsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
